import React, { useState } from "react";
import { Button } from "reactstrap";
import style from "./../NewPost.module.scss";
import { LoadingMessage } from "../../Summary";
import SendFile from "./SendFile";
import { PersonType } from "../../../../AlertSimple/Fields/types";

const Files = ({ files, hideDelete, deleteFile, loading, fetchs, ...props }) => {
  const [send, setSend] = useState({});
  const [fileTypes, setFileTypes] = useState(null);
  const [sents, setSents] = useState([]);
  const addToAccount = (event, file) => {
    event.stopPropagation();

    const sendProps = {
      open: true,
      fetchs,
      file,
      fileTypes,
      download,
      personType: props.personType,
      alias: props.alias,
      toggle: (id) => {
        setSend({});
        if (id) {
          setSents([...sents, id]);
        }
      },
    };

    if (fileTypes == null) {
      fetchs.fileTypes({}, (r) => {
        let types = null;
        if (props.personType == PersonType.All) {
          types = r.SDTGetArchivesTypes.ArchivesTypes[1];
        } else if (props.personType == PersonType.Physical) {
          types = r.SDTGetArchivesTypes.ArchivesTypes[2];
        } else {
          types = r.SDTGetArchivesTypes.ArchivesTypes[0];
        }

        setFileTypes(types.ArchivesSubTypes);
        setSend({ ...sendProps, fileTypes: types.ArchivesSubTypes });
      });
    }

    setSend(sendProps);
  };

  const download = (file) => {
    if (hideDelete) {
      fetchs.downloadFile(
        {
          eventId: file.eventId,
          eventHistoryId: file.eventHistoryId,
          eventHistoryFileId: file.id,
        },
        (r) => {
          if (r.url != "") {
            window.open(r.url);
          }
        }
      );
    }
  };

  if (loading || files == null) {
    return (
      <div className={style.files}>
        <LoadingMessage text={"Retrieving files"} />
      </div>
    );
  }

  if (send.open) {
    return (
      <div className={style.files}>
        <SendFile {...send} />
      </div>
    );
  }

  return (
    <div className={style.files}>
      {!files.length && <span className={style.empty}>{hideDelete ? "No files" : "No uploaded files"}</span>}

      {files.length > 0 && (
        <div className={style.grid}>
          {files.map((f) => (
            <div className={style.file} key={`f-${f.id}-${f.eventHistoryId}`} onClick={() => download(f)}>
              {/* Delete */}
              {!hideDelete && (
                <span className={style.delete} onClick={() => deleteFile(f.id)}>
                  <i className="fa fa-close" aria-hidden="true"></i>
                </span>
              )}
              <div className={style.overlay}>
                <span className="d-block">
                  <i className="fa fa-file-code-o" aria-hidden="true"></i>
                </span>

                {/* File name */}
                <p>{truncate(f.name.trim())}</p>

                {/* Add To account */}
                {hideDelete && !f.sent && sents.indexOf(f.id) == -1 && (
                  <div className={style.buttons}>
                    <div onClick={(e) => addToAccount(e, f)} className={style.btn}>
                      <i className="fa fa-plus" aria-hidden="true"></i>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

function truncate(input) {
  return input.length > 16 ? `${input.substring(0, 16)}...` : input;
}

export default Files;
